import { render, staticRenderFns } from "./BodyParagraph.vue?vue&type=template&id=97993c38&lang=pug"
import script from "./BodyParagraph.vue?vue&type=script&lang=ts"
export * from "./BodyParagraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports